import React from 'react';

import { UiMessageBanner } from '../../ui/ui-message-banner';

import { EmployeeCanMessage } from '../../util/can-message';
import { LANGUAGES } from '../../util/languages';
import { ContactMessageErrors } from '../../widgets/contact-message-errors';

export const EmployeeMessageBanners = ({
  canMessage,
  employee,
  messageInputHidden,
}: {
  canMessage: EmployeeCanMessage | null;
  employee: Employee;
  messageInputHidden: boolean;
}) => (
  <>
    {canMessage ? <ContactMessageErrors canMessage={canMessage} contactType="employee" /> : null}
    {!messageInputHidden &&
    employee.Contact.Person.languagePreference &&
    employee.Contact.Person.languagePreference !== 'en' ? (
      <UiMessageBanner
        variant="attention"
        message={`${employee.Contact.Person.firstName} prefers to communicate in ${
          LANGUAGES[employee.Contact.Person.languagePreference]
        }`}
        className="u-margin-top-sm u-borderRadius-5"
      />
    ) : null}
  </>
);
